/**
 * This component has the same look and feel as the TabMenu component, though semantically it doesn't use tabs, but a plain old list of links.
 */
import { useTranslation } from 'react-i18next'

import HideVisually from 'js/components/HideVisually/HideVisually'

import styles from './SkipNavigationLink.module.css'

type StyleProps = {
    top?: number
    left?: number
}

type SkipNavigationLinkProps = {
    contentId: string
    style?: StyleProps
}

const SkipNavigationLink = ({ contentId, style }: SkipNavigationLinkProps) => {
    const { t } = useTranslation()

    return (
        <HideVisually
            as="a"
            href={`#${contentId}`}
            className={styles.skipLink}
            style={
                {
                    '--skip-link-top': `${style?.top ?? 4}px`,
                    '--skip-link-left': `${style?.left ?? 4}px`,
                } as React.CSSProperties
            }
        >
            {t('action.skip-to-content')}
        </HideVisually>
    )
}

export default SkipNavigationLink
